import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function PlanTabs({ tabs, isEditor, onSwitchTab, onOpenNewSheet }) {
    return (_jsxs("div", { style: {
            flex: 'none',
            display: 'flex',
            alignItems: 'flex-end',
            background: '#EEF2F7',
            borderBottom: '1px solid #E2E8F0',
            padding: '6px 8px 0',
            gap: 4,
        }, children: [isEditor ? (_jsx("button", { type: "button", onClick: onOpenNewSheet, title: "\u041D\u043E\u0432\u044B\u0439 \u043B\u0438\u0441\u0442", className: "kp-new-tab", style: {
                    display: 'flex',
                    width: 26,
                    height: 26,
                    marginBottom: 5,
                    border: 'none',
                    borderRadius: '50%',
                    background: 'none',
                    color: '#475569',
                    fontSize: 17,
                    lineHeight: 1,
                    cursor: 'pointer',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: 'none',
                }, children: "+" })) : null, _jsx("div", { className: "kp-tab-scroll", style: { display: 'flex', alignItems: 'flex-end', gap: 3, overflowX: 'auto', flex: 1 }, children: tabs.map((t) => (_jsx("button", { type: "button", onClick: () => onSwitchTab(t.idx), title: t.title, style: {
                        flex: 'none',
                        maxWidth: 190,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        padding: '7px 16px',
                        border: `1px solid ${t.bd}`,
                        borderBottom: 'none',
                        borderRadius: '8px 8px 0 0',
                        background: t.bg,
                        color: t.color,
                        fontSize: 12.5,
                        fontWeight: t.fw,
                        cursor: 'pointer',
                    }, children: t.title }, t.idx))) })] }));
}
